import { Flex, Box, Text } from '@chakra-ui/react';
import { ImageWithSkeleton } from '../../ImageWithSkeleton';

export const ProductOption = ({
  productCode,
  name,
  iconUrl,
  handleProductSelect,
}: {
  productCode: string;
  name: string;
  iconUrl: string;
  handleProductSelect: (productCode: string) => void;
}) => (
  <Box
    p='2'
    cursor='pointer'
    _hover={{ bg: 'gray.100' }}
    onClick={() => handleProductSelect(productCode)}
    data-testid={`product-option-${productCode}`}
  >
    <Flex alignItems='center' gap={2} mt={1}>
      <ImageWithSkeleton
        width='7'
        height='7'
        src={iconUrl}
        alt={name}
        flexShrink={0}
        data-testid={`product-option-icon-${productCode}`}
      />
      <Text data-testid={`product-option-name-${productCode}`}>{name}</Text>
    </Flex>
  </Box>
);
